var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IFrameMessageService } from '@philips-internal/oswald-ui-components';
import { IFrame, IFrameAllowOptions, IFrameSandboxOptions } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import React, { Component } from 'react';
import TeleconsultattionApi from './teleconsultation-api';
import { ReactComponent as TeleconsultationSVG } from '../../assets/images/global/camera-available.svg';
import './teleconsultation.css';
const IframeActions = {
    CANCEL: 'cancel',
    MINIMIZE: 'minimize'
};
let Teleconsultation = class Teleconsultation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            closed: false,
            showFrame: false,
            showToast: false
        };
        IFrameMessageService.subscribe('oswald-eir', (message) => {
            const { action } = message;
            if (action === IframeActions.MINIMIZE) {
                this.setState({ showFrame: false, showToast: true });
            }
            else if (action === IframeActions.CANCEL) {
                this.setState({ closed: true, showFrame: false, showToast: false });
            }
        });
    }
    handleReturnClick() {
        this.setState({ showFrame: true, showToast: false });
    }
    shouldShowIframe() {
        const state = { ...this.state };
        return state.showFrame && state.url;
    }
    render() {
        const state = { ...this.state };
        return (React.createElement(React.Fragment, null,
            state.showToast && React.createElement("div", { hidden: true, className: 'toast' },
                React.createElement("span", { onClick: () => this.handleReturnClick() },
                    React.createElement(TeleconsultationSVG, { className: 'icon' }),
                    MessageService.translate('patient.teleconsultation.link.return.room'))),
            !state.closed && React.createElement("div", { hidden: !this.shouldShowIframe(), className: 'iframe' },
                React.createElement(IFrame, { height: '100%', endpoint: state.url, id: 'iframe-teleconsultation-id', allowOptions: [IFrameAllowOptions.CAMERA, IFrameAllowOptions.MICROPHONE], sandboxOptions: [IFrameSandboxOptions.ALLOW_SCRIPTS, IFrameSandboxOptions.ALLOW_SAME_ORIGIN, IFrameSandboxOptions.ALLOW_POPUPS, IFrameSandboxOptions.ALLOW_POPUPS_TO_ESCAPE_SANDBOX] }))));
    }
};
Teleconsultation = __decorate([
    AwesomeComponent({ api: TeleconsultattionApi, type: ComponentType.DATA_DISPLAY }),
    __metadata("design:paramtypes", [Object])
], Teleconsultation);
export default Teleconsultation;
//# sourceMappingURL=teleconsultation.js.map